var map = {
	"./ar.json": 68490,
	"./de.json": 96257,
	"./en.json": 99590,
	"./es.json": 65,
	"./fa.json": 17356,
	"./fr.json": 84972,
	"./my.json": 2700,
	"./pt-BR.json": 66713,
	"./ru.json": 28669,
	"./sw.json": 87346,
	"./th.json": 75391,
	"./tr.json": 17316,
	"./vi.json": 26986,
	"./zh-CN.json": 54028,
	"./zh-Hant.json": 24518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11955;